// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"r0-z"};